// extracted by mini-css-extract-plugin
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var shareLinks = "SocialLinks-module--shareLinks--h-D0-";
export var shareLinksLabel = "SocialLinks-module--shareLinksLabel--mhrbV";